import React from "react"

export const Checkmark = ({ classModifier = null, width = 32, height = 32, stroke = '#000000' }) => (
    <svg className={`checkmark ${classModifier != null ? 'checkmark--' + classModifier : ''}`} width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="checkmark">
            <g id="Group">
                <path id="Vector" d="M7.33301 14.6668L13.9997 21.3335L25.9997 9.3335" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </g>
        </g>
    </svg>
)